import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { ExportedIcon } from '../icons/icons';

export const NewNavbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [industryDropdownOpen, setIndustryDropdownOpen] = useState(false);
  const [mobileIndustryDropdownOpen, setMobileIndustryDropdownOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleIndustryDropdown = () => setIndustryDropdownOpen(!industryDropdownOpen);
  const toggleMobileIndustryDropdown = () =>
    setMobileIndustryDropdownOpen(!mobileIndustryDropdownOpen);

  const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'Employer', href: '/employer' },
    { label: 'Workforce Organizations', href: '/workforce' },
    { label: 'Schools & Education', href: '/education' },
    {
      label: 'Industry',
      href: '#',
      children: [
        { label: 'Healthcare', href: '/healthcare' },
        { label: 'Retail', href: '/retail' },
        { label: 'Logistics', href: '/logistics' },
        { label: 'Manufacturing', href: '/manufacturing' },
        { label: 'Team', href: '/team' },
      ],
    },
  ];

  const loginLink = '/login';

  return (
    <header
      className={`fixed w-full top-0 z-50 ${
        isMenuOpen ? 'bg-white text-black' : 'backdrop-blur-0 bg-black/15 text-white'
      } transition-colors duration-300`}
    >
      <div className="container mx-auto px-4 flex items-center justify-between h-20 md:h-24">
        {/* Desktop Nav */}
        <nav className="hidden md:flex md:space-x-6 lg:space-x-10 items-center">
          {navLinks.map((link, index) => (
            <div key={index} className="relative">
              {link.children ? (
                <div className="flex items-center gap-1 group relative">
                  <Link to={link.href!} className="hover:text-[#a0c4ff] transition font-medium">
                    {link.label}
                  </Link>
                  <button
                    type="button"
                    onClick={toggleIndustryDropdown}
                    className="focus:outline-none"
                  >
                    <ArrowDropDownIcon />
                  </button>

                  {industryDropdownOpen && (
                    <div className="absolute top-full left-0 mt-2 w-48 bg-white text-black rounded-md shadow-lg transition-opacity duration-300 z-50">
                      <div className="flex flex-col">
                        {link.children.map((child, childIndex) => (
                          <Link
                            key={childIndex}
                            to={child.href}
                            className="px-4 py-2 hover:bg-gray-100"
                          >
                            {child.label}
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <Link to={link.href!} className="hover:text-[#a0c4ff] transition font-medium">
                  {link.label}
                </Link>
              )}
            </div>
          ))}
        </nav>

        {/* Right section */}
        <div className="flex items-center ml-auto">
          <a href={loginLink} rel="noopener noreferrer" className="btn btn-primary">
            Login <ExportedIcon style={{ fontSize: 10 }} />
          </a>

          <button
            onClick={toggleMenu}
            type="button"
            className="md:hidden ml-3 sm:ml-4 focus:outline-none"
            aria-label="Toggle Menu"
          >
            <MenuIcon sx={{ fontSize: '32px' }} />
          </button>
        </div>
      </div>

      {/* Background overlay */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-40 transition-opacity duration-300"
          onClick={toggleMenu}
        />
      )}

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 h-screen left-0 inset-0 z-[999] bg-white transform ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        } transition-transform duration-300 ease-in-out overflow-y-auto max-h-screen`}
      >
        <button
          onClick={toggleMenu}
          className="absolute top-6 right-6 text-black"
          aria-label="Close Menu"
        >
          <CloseIcon className="w-8 h-8" />
        </button>

        <nav className="h-full px-6 py-12 flex flex-col items-center text-black gap-6 text-base sm:text-lg font-medium">
          {navLinks.map((link, index) => (
            <div key={index} className="flex flex-col items-center gap-2">
              {link.children ? (
                <>
                  <div className="flex items-center gap-1">
                    <Link
                      to={link.href!}
                      onClick={toggleMenu}
                      className="hover:font-semibold transition"
                    >
                      {link.label}
                    </Link>
                    <button
                      type="button"
                      onClick={toggleMobileIndustryDropdown}
                      className="focus:outline-none"
                    >
                      <ArrowDropDownIcon />
                    </button>
                  </div>
                  {mobileIndustryDropdownOpen && (
                    <div className="flex flex-col items-center gap-1 transition-all duration-300 ease-in-out">
                      {link.children.map((child, childIndex) => (
                        <Link
                          key={childIndex}
                          to={child.href}
                          onClick={toggleMenu}
                          className="text-sm text-gray-600 hover:text-black transition"
                        >
                          {child.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <Link
                  to={link.href!}
                  onClick={toggleMenu}
                  className="hover:font-semibold transition"
                >
                  {link.label}
                </Link>
              )}
            </div>
          ))}
        </nav>
      </div>
    </header>
  );
};
